import { Svg, SvgPath, SvgProps } from '@rbilabs/universal-components';
import { Rect } from 'react-native-svg';

interface ICheckboxIconProps extends SvgProps {
  $isSelected?: boolean;
}

export const CheckboxIcon = ({ $isSelected = false, ...props }: ICheckboxIconProps) => {
  const size = props.size || 24;
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill={'none'}>
      <Rect
        width={24}
        height={24}
        rx="4.17671"
        fill={$isSelected ? props.fill || '#502314' : 'white'}
      />
      <SvgPath
        d="M9.91169 14.9028L7.00887 12L6.02039 12.9815L9.91169 16.8728L18.2651 8.51937L17.2836 7.53784L9.91169 14.9028Z"
        fill="white"
      />
    </Svg>
  );
};
